// components/socuals/pages/PostPage.jsx
import { useNavigate, useParams } from "react-router-dom";

import PostDetail from "../PostDetail";

export default function PostPage() {
  const { postId } = useParams();
  const navigate = useNavigate();

  return (
    <main className="social-route-page post-route-page">
      <div className="post-route-page__phone">
        <PostDetail
          postId={postId}
          active
          fullscreen
          onOpenAuthor={(uid) => navigate(`/profile/${uid}`)}
          onDeleted={() => navigate(-1)}
        />
      </div>
    </main>
  );
}
